import React from "react";
import { Outlet, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";

export default function MainLayout() {
  const location = useLocation();

  // Hide footer on survey pages only
  const isSurveyRoute = location.pathname.startsWith("/survey/");

  return (
    <>
      <Header className="site-header" />

      <Outlet />

      {!isSurveyRoute && <Footer />}
    </>
  );
}
